import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import store from "./store/store";
import App from './App';
import reportWebVitals from './reportWebVitals';


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
const initAnalytics = () => {
  import("firebase/app").then(({ initializeApp }) => {
    import("firebase/analytics").then(({ getAnalytics }) => {
      const firebaseApp = initializeApp(firebaseConfig);
      getAnalytics(firebaseApp);
    });
  });
};

const interactionEvents: (keyof WindowEventMap)[] = [
  "pointerdown",
  "keydown",
  "scroll",
  "touchstart",
];

let analyticsStarted = false;

const startAnalyticsOnce = () => {
  if (analyticsStarted) return;
  analyticsStarted = true;
  interactionEvents.forEach((evt) =>
    window.removeEventListener(evt, startAnalyticsOnce),
  );
  clearTimeout(fallbackId);
  initAnalytics();
};

interactionEvents.forEach((evt) =>
  window.addEventListener(evt, startAnalyticsOnce, {
    once: true,
    passive: true,
  }),
);

const fallbackId = setTimeout(startAnalyticsOnce, 8000);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(

    <Provider store={store}>
      <App />
    </Provider>

);


reportWebVitals();
